var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.2012836,14.0081187 L0,14.0081187 L0,10.5081187 L19.3762251,10.5081187 L11.3376224,2.57101352 L13.796723,0.0804665774 L26.5426289,12.6654393 L13.796723,25.250412 L11.3376224,22.7598651 L20.2012836,14.0081187 Z","fill":"currentColor","fillRule":"nonzero"}));
}

IconArrow.defaultProps = {"width":"27px","height":"26px","viewBox":"0 0 27 26","version":"1.1"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
